import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import Slider from "rc-slider";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { responseStatus, standardErrorsWay } from "../../../utils/consts";
import {
  StyledCalculateRange,
  StyledCalculatorContent,
  StyledCalculatorContentInfo,
  StyledCalculatorContentRange,
  StyledHomePageCalculatorBlock,
  StyledHomePageCalculatorSection,
  StyledRangeBadge
} from "./styledPriceCalculator";
import { StyledDecorationElementHomePage, StyledHomePageContainer, StyledMainTitleHomePage } from "../styledHomePage";
import { StyledButton } from "../../styles/styledButton";
import { NavLink } from "react-router-dom";
import { parseAxiosError } from "../../../utils/response";
import { HookResponsive } from "../../elements/customHooks/HookResponsive";

const HomePagePriceCalculator = () => {

  const [tariff, setTariff] = useState({ managers: 1, projects: 1 });

  const [calculatorState, setCalculateState] = useState({ month: 1, managers: 1, projects: 1 });

  const fetchPublicTariffs = () => {
    axios.get("/api/get-public-tariff", userAuthenticationConfig()).then(response => {
      if (response.status === responseStatus.HTTP_OK) {

        const currentTariff = response.data.currentTariff;

        setTariff({
          managers: Number(currentTariff.pricePerManager).toFixed(2),
          projects: Number(currentTariff.pricePerProject).toFixed(2)
        });
      }
    }).catch(error => {
      parseAxiosError(eval(standardErrorsWay));
    });
  };
  const changeSliderRangeMonth = (value) => {
    setCalculateState(prev => ({ ...prev, month: value }));
  };

  const changeSliderRangeManagers = (value) => {
    setCalculateState(prev => ({ ...prev, managers: value }));
  };
  const changeSliderRangeProjects = (value) => {
    setCalculateState(prev => ({ ...prev, projects: value }));
  };

  const priceMonthCalculate = (calculatorState, tariff) => {
    const counter = ((calculatorState.projects * tariff.projects) + (calculatorState.managers * tariff.managers)) * 30;

    if (counter.toString().includes(".")) {
      return counter.toFixed(2);
    } else {
      return counter;
    }

  };

  const priceMonthCalculateMemo = useMemo(() => priceMonthCalculate(calculatorState, tariff),
    [calculatorState, tariff]);

  const priceTotalCalculate = (priceMonthCalculateMemo, calculatorStateMonth) => {
    const counter = priceMonthCalculateMemo * calculatorStateMonth;

    if (counter.toString().includes(".")) {
      return counter.toFixed(2);
    } else {
      return counter;
    }

  };

  const priceTotalCalculateMemo = useMemo(() => priceTotalCalculate(priceMonthCalculateMemo, calculatorState.month),
    [priceMonthCalculateMemo, calculatorState.month]);

  useEffect(() => {
    fetchPublicTariffs();
  }, []);

  const textAnimation = {
    hidden: {
      x: 50,
      opacity: 0
    },
    visible:{
      x: 0,
      opacity: 1,
      transition: { delay:  0.5 }
    }
  };

  const calcAnimate = {
    hidden: {
      y: -40,
      opacity: 0
    },
    visible: custom => ({
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 300, damping: 10, delay: custom * 0.2 }
    })
  };

  return (
    <StyledHomePageCalculatorSection
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <StyledHomePageContainer>
        <StyledHomePageCalculatorBlock>
          <StyledCalculatorContent>
            <StyledCalculatorContentRange>
              <StyledCalculateRange
                custom={1}
                variants={HookResponsive() ? calcAnimate : null}
              >
                <div className="about-range">
                  <StyledDecorationElementHomePage
                    color="#FFFFFF"
                    weigth="700"
                    size="25"
                  >Month</StyledDecorationElementHomePage>
                  <StyledRangeBadge>{priceMonthCalculateMemo}</StyledRangeBadge>
                </div>
                <Slider
                  onChange={changeSliderRangeMonth}
                  className="slider-range"
                  min={1}
                  max={5}
                  step={1}
                  marks={{ 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 }}
                />
              </StyledCalculateRange>
              <StyledCalculateRange
                custom={2}
                variants={HookResponsive() ? calcAnimate : null}
              >
                <div className="about-range">
                  <StyledDecorationElementHomePage
                    color="#FFFFFF"
                    weigth="700"
                    size="25"
                  >Managers</StyledDecorationElementHomePage>
                  <StyledRangeBadge>{tariff.managers * calculatorState.managers}</StyledRangeBadge>
                </div>
                <Slider
                  onChange={changeSliderRangeManagers}
                  className="slider-range"
                  min={1}
                  max={5}
                  step={1}
                  marks={{ 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 }}
                />
              </StyledCalculateRange>
              <StyledCalculateRange
                custom={3}
                variants={HookResponsive() ? calcAnimate : null}
              >
                <div className="about-range">
                  <StyledDecorationElementHomePage
                    color="#FFFFFF"
                    weigth="700"
                    size="25"
                  >Projects</StyledDecorationElementHomePage>
                  <StyledRangeBadge>{tariff.projects * calculatorState.projects}</StyledRangeBadge>
                </div>
                <Slider
                  onChange={changeSliderRangeProjects}
                  className="slider-range"
                  min={1}
                  max={5}
                  step={1}
                  marks={{ 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 }}
                />
              </StyledCalculateRange>
              <motion.div
                className="total-range"
                custom={4}
                variants={HookResponsive() ? calcAnimate : null}
              >
                <StyledDecorationElementHomePage
                  color="#FFFFFF"
                  weigth="700"
                  size="36"
                >Total :</StyledDecorationElementHomePage>
                <StyledRangeBadge className="total-badge">{priceTotalCalculateMemo}</StyledRangeBadge>
              </motion.div>
            </StyledCalculatorContentRange>
            <StyledCalculatorContentInfo
              variants={HookResponsive() ? textAnimation : null}
            >
              <StyledMainTitleHomePage
                color="white"
                className="main-title"
                size="50"
                lineHeight="50"
                weight="700"
              >
                Price calculate
              </StyledMainTitleHomePage>
              <div className="main-content">
                <StyledDecorationElementHomePage
                  display="block"
                  lineHeight="23"
                  color="#FFFFFF"
                  weight="300"
                  size="16"
                >
                  Text me does not have any tariff plans that can be limited to one or another number of services. There
                  are only individual miscalculations, thanks to which you can choose the number of projects, managers,
                  etc. necessary for the quality service of your clients.
                </StyledDecorationElementHomePage>
              </div>
              <StyledButton
                color="white"
                as={NavLink}
                to={`/tariff-and-subscription?manager=${calculatorState.managers}&project=${calculatorState.projects}`}
                size="18"
                className="calculate-btn"
              >
                Calculate project
              </StyledButton>
            </StyledCalculatorContentInfo>
            <StyledButton
              variants={HookResponsive() ? textAnimation : null}
              custom={3}
              color="white"
              as={NavLink}
              to={`/tariff-and-subscription?manager=${calculatorState.managers}&project=${calculatorState.projects}`}
              size="18"
              className="calculate-btn-response"
            >
              Calculate project
            </StyledButton>
          </StyledCalculatorContent>
        </StyledHomePageCalculatorBlock>
      </StyledHomePageContainer>
    </StyledHomePageCalculatorSection>
  );

};

export default HomePagePriceCalculator;